import React from "react";

const BrokenComponent = () => {
  throw new Error("I crashed!");
  return <div>Unreachable code</div>;
};

export default BrokenComponent;
